import { render, staticRenderFns } from "./ContactAttribute.vue?vue&type=template&id=34d0e630&scoped=true&"
import script from "./ContactAttribute.vue?vue&type=script&lang=js&"
export * from "./ContactAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ContactAttribute.vue?vue&type=style&index=0&id=34d0e630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0e630",
  null
  
)

export default component.exports